import styled from 'styled-components';
import { color } from 'styles/Theme';

export const ListContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.3rem;
`;

export const ListItem = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
	padding: 0.3rem;
	border-bottom: 1px solid ${color.interface.lightGray};
	transition: box-shadow 0.2s;

	&:hover {
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}
`;

export const Checkbox = styled.input`
	width: 20px;
	height: 20px;
	cursor: pointer;
`;

export const MapInfo = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
`;

export const MapName = styled.span`
	font-weight: 500;
	color: ${color.interface.brown};
`;

export const MapDetails = styled.span`
	font-size: 0.75rem;
	color: ${color.interface.gray};
`;

export const DeleteButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0.5rem;
	background: transparent;
	color: ${color.interface.orange};
	cursor: pointer;
	transition: all 0.2s;

	&:hover:not(:disabled) {
		color: ${color.interface.red};
		zoom: 1.1;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	svg {
		font-size: 1.125rem;
	}
`;

export const Loading = styled.div`
	padding: 2rem;
	text-align: center;
	color: ${color.interface.gray};
`;

export const Empty = styled.div`
	padding: 2rem;
	text-align: center;
	color: ${color.interface.gray};
	font-style: italic;
`;

export const ErrorMessage = styled.div`
	text-align: center;
	color: ${color.system.error};
	font-size: 14px;
	margin: 8px 0;
`;

export const ErrorText = styled.div`
	color: ${color.system.error};
	font-size: 12px;
	white-space: pre-line;
`;
